import {
  GET_MULTI_ACCOUNT_REDESIGNED_DASHBOARD_DETAILS_FULFILLED,
  GET_MULTI_ACCOUNT_REDESIGNED_DASHBOARD_DETAILS_FAILED,
  GET_MULTI_ACCOUNT_REDESIGNED_DASHBOARD_DETAILS_PENDING,
  SET_SELECTED_ACCOUNT_DETAILS,
  SET_SELECT_CUSTOMER_CLICKED,
  SET_MULTI_ACCOUNT_DASHBOARD_TAB_SELECTED,
  RESET_MULTI_ACCOUNT_DETAILS,
} from "constants-lib/actionTypes"

export const initialState = {
  selectedAccountDetails: {},
  isSelectCustomerDDClicked: true,
  customerId: "",
  multiAccountDashboardTabSelected: "",
  multiAccountDashboardDetails: {},
  multiAccountDashboardDetailsStatus: "",
}

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case RESET_MULTI_ACCOUNT_DETAILS:
      return {
        ...state,
        ...initialState,
      }
    case SET_SELECTED_ACCOUNT_DETAILS:
      return {
        ...state,
        selectedAccountDetails: action.payload.selectedAccountDetails,
        customerId: action.payload.selectedAccountDetails?.custAccountId || "",
      }
    case SET_SELECT_CUSTOMER_CLICKED:
      return {
        ...state,
        isSelectCustomerDDClicked: action.payload.isSelectDDClicked,
      }
    case SET_MULTI_ACCOUNT_DASHBOARD_TAB_SELECTED:
      return {
        ...state,
        multiAccountDashboardTabSelected: action.payload.tabSelected,
      }
    case GET_MULTI_ACCOUNT_REDESIGNED_DASHBOARD_DETAILS_FULFILLED:
      return {
        ...state,
        multiAccountDashboardDetails: action.payload.accountsResponseData,
        multiAccountDashboardDetailsStatus: "fulfilled",
      }
    case GET_MULTI_ACCOUNT_REDESIGNED_DASHBOARD_DETAILS_FAILED:
      return {
        ...state,
        multiAccountDashboardDetails: {},
        multiAccountDashboardDetailsStatus: "failed",
      }
    case GET_MULTI_ACCOUNT_REDESIGNED_DASHBOARD_DETAILS_PENDING:
      return {
        ...state,
        multiAccountDashboardDetails: {},
        multiAccountDashboardDetailsStatus: "pending",
      }
    default:
      return state
  }
}
